<template>
  <div>
    <b-modal id="form-calculation-salary" size="md" no-close-on-backdrop :title="(editId == null ? 'Tambah' : 'Edit') + ' ' + pageTitle">
      <validation-observer ref="countSalaryRef">
        <form>
            <horizontal-form-group label="Periode Gaji">
              <validation-provider #default="{ errors }" name="Periode Gaji" rules="required">
                <input locale="id" type="hidden" v-model="formPayloadSalary.periodeSalary"></input>
                <month-picker-input :default-year="formPayloadSalary.years" :default-month="formPayloadSalary.month" :no-default="true" @change="DateChange"></month-picker-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </horizontal-form-group>
            <horizontal-form-group label="Tgl Mulai">
              <validation-provider #default="{ errors }" name="Tgl Mulai" rules="required">
                <b-form-datepicker v-model="formPayloadSalary.startDate"></b-form-datepicker>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </horizontal-form-group>
            <horizontal-form-group label="Tgl Akhir">
              <validation-provider #default="{ errors }" name="Tgl Akhir" rules="required">
                <b-form-datepicker v-model="formPayloadSalary.endDate"></b-form-datepicker>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </horizontal-form-group>
            <horizontal-form-group label="Masa Kenaikan Gaji">
              <validation-provider #default="{ errors }" name="Masa Kenaikan Gaji" rules="required">
                <b-form-select v-model="formPayloadSalary.salaryIncreasePeriod" :options="optionsSalary" >
<!--                  <b-form-select-option v-if="formPayloadSalary.salaryIncreasePeriod !== null" :value="formPayloadSalary.salaryIncreasePeriod">{{ formPayloadSalary.salaryIncreasePeriod ? formPayloadSalary.salaryIncreasePeriod.text : 'Please select an option' }}</b-form-select-option>-->
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </horizontal-form-group>
        </form>
      </validation-observer>
      <template #modal-footer="{}">
        <b-button class="d-flex" @click="submitItem" :disabled="loadingSalary" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary">
          <b-spinner v-if="loadingSalary" small variant="light" class="mr-1" /> Simpan
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import { BCard,
  BRow,
  BCol,
  BButton,
  BFormInput,
  BFormDatepicker,
  BSpinner,
  BFormSelect,
  BFormSelectOption
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility';
import { MonthPickerInput } from 'vue-month-picker'
import { PayslipAutoServices } from '../../services/component-salary.service'
export default {
  name: "CalculationSalaryForm",
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput,
    ValidationProvider,
    ValidationObserver,
    BFormDatepicker,
    BSpinner,
    BFormSelect,
    MonthPickerInput,
    BFormSelectOption
  },
  directives: {
    Ripple,
  },
  props: {
    formPayload: {
      type: ""
    },
    pageTitle: {
      type: String,
    },
    loading: {
      type: Boolean
    },
    editId: {
      type: Number,
    },
    getData: {
      type: Function
    }
  },
  data() {
    return {
      formPayloadSalary: {
        periodeSalary: "",
        startDate: "",
        endDate: "",
        salaryIncreasePeriod: null,
        years: 0,
        month: 0
      },
      loadingSalary: false,
      optionsSalary: [
        {
          text: "Ya",
          value: true
        },
        {
          text: "Tidak",
          value: false
        }
      ]
    }
  },
  watch: {
    loading(value) {
      this.loadingSalary = value;
    },
    'formPayload': function (value) {
      // window.console.log(utility.TimeStampToDate(value.startDate));
      this.formPayloadSalary.years = parseInt(utility.FormatYearMonth(value.periodeSalary).year);
      this.formPayloadSalary.month = parseInt(utility.FormatYearMonth(value.periodeSalary).month);
      this.formPayloadSalary.startDate = utility.TimeStampToDate(value.startDate);
      this.formPayloadSalary.endDate = utility.TimeStampToDate(value.endDate);
      if (value.salaryIncreasePeriod !== null) {
        this.formPayloadSalary.salaryIncreasePeriod = value.salaryIncreasePeriod.value;
      }

    }
  },
  methods: {
    submitItem() {
      this.$refs.countSalaryRef.validate()
        .then((result) => {
          window.console.log(result);
          if (result) {
            if (this.editId === null) {
              this.Save();
            } else {
              this.Update();
            }
          }
        });
    },
    ResetField() {
      this.getData();
      this.loadingSalary = false;
      this.formPayloadSalary = {
        periodeSalary: "",
        startDate: "",
        endDate: "",
        salaryIncreasePeriod: null
      };
    },
    Save() {
        window.console.log(this.formPayloadSalary);
        let req = {
          startDate: new Date(this.formPayloadSalary.startDate).toISOString(),
          endDate: new Date(this.formPayloadSalary.endDate).toISOString(),
          isAdjustment: this.formPayloadSalary.salaryIncreasePeriod,
          period: this.formPayloadSalary.periodeSalary
        };
        this.loadingSalary = true;
        this.$http.post('/payslip/payslip-auto', req)
          .then((result) => {
            if (result.data.code === "00") {
              this.editId = null;
              successNotification(this, "Success",result.data.message);
              this.ResetField();
              return this.$bvModal.hide('form-calculation-salary');
            }
            this.loadingSalary = false;
            window.console.log(result);
            return errorNotification(this, "Oops!", result.data.message);
          })
          .catch((e) => {
            this.loadingSalary = false;
            return errorNotification(this, "Oops!", e.message);
          });
    },
    async Update() {
      window.console.log(this.editId);
      let req = {
        startDate: new Date(this.formPayloadSalary.startDate).toISOString(),
        endDate: new Date(this.formPayloadSalary.endDate).toISOString(),
        isAdjustment: this.formPayloadSalary.salaryIncreasePeriod,
        period: this.formPayloadSalary.periodeSalary
      };
      window.console.log(req);
      this.loadingSalary = true;
      await PayslipAutoServices.update(this.editId, req)
        .then((result) => {
          window.console.log(result);
          if (result.data.code === "00") {
            successNotification(this, "Success",result.data.message);
            this.ResetField();
            this.$bvModal.hide('form-calculation-salary');
          }
          this.loadingSalary = false;
        })
        .catch((e) => {
          this.loadingSalary = false;
          return errorNotification(this, "Oops!", e.message);
        });
    },
    DateChange(time) {
      window.console.log(time);
      let numberIndex = `${time.monthIndex}`;
      if (time.monthIndex <= 9) {
        numberIndex   =  `0${time.monthIndex}`;
      }
      window.console.log(numberIndex);
      this.formPayloadSalary.periodeSalary = `${time.year}-${numberIndex}`;
    }
  }
}
</script>
